var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtNodeAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#E5F6FF",
    stroke: "#1276D3",
    strokeDasharray: "1 1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3181 4.51885L15.0103 8.82673L3.38913 5.30257L2.0293 6.66244L10.9307 12.9064L6.75341 17.0825L3.28171 16.2304L2 17.5098L5.90016 20.1013L8.49045 24.0003L9.77098 22.7198L8.91898 19.2469L21.4824 6.68197L22 4L19.3181 4.51885Z",
    fill: "#1192E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.599 15.7898L19.3375 23.971L20.6974 22.6111L17.4588 11.9286L13.599 15.7898Z",
    fill: "#1192E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtNodeAir);
export default __webpack_public_path__ + "static/media/AtNodeAir.3dcebfd87356c9695710ffe53c9001a8.svg";
export { ForwardRef as ReactComponent };